import { Box } from "@mui/material";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import React from "react";
import { Bar } from "react-chartjs-2";

import { colorPool } from "@/module/service-configs-module/statistics-visualization-module/first-svetofor/util";
import { PlayerTimingsPeriodDto } from "@/shared/api";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const colors = {
  ecology: "rgba(34, 197, 94, 0.8)",
  live: "rgba(251, 146, 60, 0.8)",
};

const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: "top" as const },
    //title: { display: true, text: "Median Timings" },
  },
  scales: {
    x: { stacked: true },
    y: { stacked: true },
  },
};

/*type TimingSummary = {
  periodEntries: number; //Record of entries for the period. Service field
  heroTiming: number;
  opponentTiming: number;
  subOpponentsTiming: number;
};*/

//new
type TimingEntry = {
  sum: number;
  count: number;
};

type TimingSummary = {
  hero: TimingEntry;
  opponent: TimingEntry;
  subOpponents: Map<number, TimingEntry>; // key = index of subOpponent
};
//

export default function MedianTimingsChart({ data }: { data: PlayerTimingsPeriodDto[] }) {
  const sortedData = data.sort((el1, el2) => el1.period.localeCompare(el2.period));

  // Этот метод используется для получения таймингов игроков по периодам.
  // Здесь мы складываем не разделяя на stage и action, а просто суммируем тайминги за день для каждого эктора. ?????????????????????????
  const timingByPeriod = sortedData.reduce((acc, item) => {
    const { period, heroTiming, opponentTiming, subOpponentsTimings } = item;

    if (!acc.has(period)) {
      acc.set(period, {
        hero: { sum: 0, count: 0 },
        opponent: { sum: 0, count: 0 },
        subOpponents: new Map<number, TimingEntry>(),
      });
    }

    const current = acc.get(period)!;

    if (heroTiming > 0) {
      //Учитываем только те тайминги больше нуля
      current.hero.sum += heroTiming;
      current.hero.count++;
    }

    if (opponentTiming > 0) {
      //Учитываем только те тайминги больше нуля
      current.opponent.sum += opponentTiming;
      current.opponent.count++;
    }

    //Считаем тайминги для каждого субоппонента. Принимаем то, что в массиве индекс числа является индексом субоппонента
    subOpponentsTimings.forEach((timing, index) => {
      if (timing <= 0) return;

      const subMap = current.subOpponents;
      if (!subMap.has(index)) {
        subMap.set(index, { sum: 0, count: 0 });
      }

      const entry = subMap.get(index)!;
      entry.sum += timing;
      entry.count++;
    });

    return acc;
  }, new Map<string, TimingSummary>());

  // Преобразуем Map в массив объектов для построения графика
  const result = timingByPeriod
    .entries()
    .map(([period, timings]) => {
      //Считаем среднее за день
      const heroTimingAvgPerPeriod = (timings.hero.sum =
        timings.hero.count > 0 ? timings.hero.sum / timings.hero.count : 0);
      const mainOpponentTimingAvgPerPeriod = (timings.opponent.sum =
        timings.opponent.count > 0 ? timings.opponent.sum / timings.opponent.count : 0);

      //Cчитаем среднее за день для каждого субоппонента и добавляем их как поля финального объекта
      const subOpponentsCalculatedObject = timings.subOpponents
        .entries()
        .reduce((acc, [subOpIndex, subOpTimingEntry]) => {
          acc[`subopponent_${subOpIndex}`] =
            subOpTimingEntry.count > 0 ? subOpTimingEntry.sum / subOpTimingEntry.count : 0;
          return acc;
        }, {} as Record<string, number>);

      // Calculate average timings for each subOpponent
      return {
        period,
        heroTimingAvgPerPeriod,
        mainOpponentTimingAvgPerPeriod,
        ...subOpponentsCalculatedObject,
      };
    })
    .toArray()
    .reduce((acc, item) => {
      //Костыль. Меняем структуру объекта, чтобы в итоге получить объект с ключами - именами акторов и значениями - массивами таймингов
      for (const key in item) {
        // @ts-expect-error valid
        if (typeof item[key] === "number") {
          if (!acc[key]) {
            acc[key] = [];
          }
          // @ts-expect-error valid
          acc[key].push(item[key]);
        }
      }
      return acc;
    }, {} as Record<string, number[]>);

  return (
    <>
      {Object.entries(result).map(([actor, timings], index) => {
        return (
          <Box key={actor} mt={2}>
            <Bar
              data={{
                labels: Array.from(timingByPeriod.keys()),
                datasets: [
                  {
                    label: actor.charAt(0).toUpperCase() + actor.slice(1),
                    data: timings.map((timing) => timing / 1000), //1000 ms, convert to seconds
                    backgroundColor: colorPool[index], // Use the first color from the pool
                  },
                ],
              }}
              options={barChartOptions}
            />
          </Box>
        );
      })}
    </>
  );
}
